import { useQuery } from '@apollo/client';

import { GetInterviewBookingDocument } from '@xing-com/crate-jobs-graphql';

type BookingInfoResponse = {
  isLoading: boolean;
  hasInterviewBookingAvailable?: boolean;
  editInterviewBookingUrl?: string;
};

type Props = {
  jobId: string;
  skip?: boolean;
};

export const useInterviewBookingInfo = ({
  jobId,
  skip = false,
}: Props): BookingInfoResponse => {
  const { loading, data } = useQuery(GetInterviewBookingDocument, {
    variables: { jobId },
    skip,
  });

  if (loading) return { isLoading: true };

  return {
    isLoading: false,
    hasInterviewBookingAvailable: data?.viewer?.jobBooking?.availability,
    editInterviewBookingUrl:
      data?.viewer?.jobBooking?.editBookingUrl ?? undefined,
  };
};
